import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth, homeRouteFor, TECNICO_ALLOWED_ROUTES } from './hooks/useAuth';
import './styles/global.css';

import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import ClientesPage from './pages/ClientesPage';
import ProyectosPage from './pages/ProyectosPage';
import CitasPage from './pages/CitasPage';
import AgendaPage from './pages/AgendaPage';
import CalculadoraPage from './pages/CalculadoraPage';
import CotizacionesPage from './pages/CotizacionesPage';
import PerfilPage from './pages/PerfilPage';
import HojasTecnicasPage from './pages/HojasTecnicasPage';
import PreciosPage from './pages/PreciosPage';
import CorreoMasivoPage from './pages/CorreoMasivoPage';
import ObraPage from './pages/ObraPage';
import AdminPage from './pages/AdminPage';
import Layout from './components/layout/Layout';

const PrivateRoute = ({ children, adminOnly = false }) => {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();
  if (loading) return <div style={{ display:'flex', justifyContent:'center', alignItems:'center', height:'100vh' }}><div className="spinner spinner-dark"/></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !isAdmin) return <Navigate to={homeRouteFor(user.rol)} replace />;
  // El técnico solo puede ver sus propias secciones (Agenda, Calculadora, Obra, Perfil) —
  // cualquier otra ruta (incluida /dashboard) lo redirige a Obra.
  if (user.rol === 'tecnico' && !TECNICO_ALLOWED_ROUTES.includes(location.pathname)) {
    return <Navigate to="/obra" replace />;
  }
  return children;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to={homeRouteFor(user.rol)} replace />;
  return children;
};

const HomeRedirect = () => {
  const { user } = useAuth();
  return <Navigate to={homeRouteFor(user?.rol)} replace />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/forgot-password" element={<PublicRoute><ForgotPasswordPage /></PublicRoute>} />
      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<HomeRedirect />} />
        <Route path="dashboard"     element={<DashboardPage />} />
        <Route path="clientes"      element={<ClientesPage />} />
        <Route path="proyectos"     element={<ProyectosPage />} />
        <Route path="cotizaciones"  element={<CotizacionesPage />} />
        <Route path="citas"         element={<CitasPage />} />
        <Route path="agenda"        element={<AgendaPage />} />
        <Route path="calculadora"   element={<CalculadoraPage />} />
        <Route path="hojas-tecnicas" element={<HojasTecnicasPage />} />
        <Route path="precios" element={<PrivateRoute adminOnly><PreciosPage /></PrivateRoute>} />
        <Route path="correo-masivo" element={<CorreoMasivoPage />} />
        <Route path="obra" element={<ObraPage />} />
        <Route path="perfil"        element={<PerfilPage />} />
        <Route path="admin"         element={<PrivateRoute adminOnly><AdminPage /></PrivateRoute>} />
      </Route>

      <Route path="*" element={<PrivateRoute><HomeRedirect /></PrivateRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" toastOptions={{ duration: 4000, style: { fontFamily: 'Inter, sans-serif', fontSize: '14px' } }} />
      </BrowserRouter>
    </AuthProvider>
  );
}
